import './fond.css'

const Fond = () => {
    
    return (
        <div className="fond"></div>
)
    
}

export default Fond